import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventConversationBulkFavorite } from 'entities/Call'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ILocalTypeInbox } from 'entities/Inbox'

export const useEventConversationBulkFavorite = (view: ILocalTypeInbox) => {
  const { websocket, conversationStore } = useEntitiesContext()
  const handler = (data: IResponseEventConversationBulkFavorite) => {
    const { getItem } = conversationStore

    data.ids.forEach((conversationId) => {
      const conversation = getItem(conversationId)
      if (!conversation) return

      conversation.updatePriority(data.isFavorite)
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationsBulkFavorite, handler), [view])
}
